import { Directive, Input } from '@angular/core';
import { ClickEventAbstract } from '@df/ui/common/click-event.abstract';

@Directive({
    selector: '[minibasketToggle]',
    standalone: true
})
export class MinibasketToggleDirective extends ClickEventAbstract {
    /**
     * Event name to broadcast.
     *
     * @type {string}
     * @memberof MinibasketToggleDirective
     */
    name: string = 'minibasket.toggle.request';

    /**
     * Data to broadcast.
     *
     * @type {*}
     * @memberof MinibasketToggleDirective
     */
    @Input('minibasketToggle') set minibasketToggle(value: any) {
        this.data = value;
    }
}
